"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ExerciseMultipleChoiceMediaWrapper = function ExerciseMultipleChoiceMediaWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "languageId", _descriptor, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "mediaWidth",
      get: function get() {
        return _state.DeckUI.layout.deckWidth / 2;
      }
    }, {
      key: "exercise",
      get: function get() {
        return this.props.exercise || _state.ExerciseUI.exercise;
      }
    }, {
      key: "background",
      value: function background(exerciseEntry, option) {
        if (this.isSelected(exerciseEntry, option) && !exerciseEntry.state.revealed) {
          return _state.AppUI.site.accentColor || _constants.Theme.blue;
        } else if (exerciseEntry.state.revealed && option.correct) {
          return _constants.Theme.green;
        } else if (exerciseEntry.state.revealed && this.isSelected(exerciseEntry, option) && !option.correct) {
          return _constants.Theme.red;
        }
        return 'white';
      }
    }, {
      key: "color",
      value: function color(exerciseEntry, option) {
        if (this.isSelected(exerciseEntry, option)) {
          return 'white';
        } else if (exerciseEntry.state.revealed && option.correct) {
          return 'white';
        }
        return 'black';
      }
    }, {
      key: "isSelected",
      value: function isSelected(exerciseEntry, option) {
        var _exerciseEntry$state$;
        return (_exerciseEntry$state$ = exerciseEntry.state.submittedValue) === null || _exerciseEntry$state$ === void 0 ? void 0 : _exerciseEntry$state$.includes(option.id);
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        var _this$props$exercise;
        return (0, _utils.isPresent)((_this$props$exercise = this.props.exercise) === null || _this$props$exercise === void 0 ? void 0 : _this$props$exercise.exerciseEntries) ? _state.DeckUI.layout.contentHeightWithMultipleChoiceButtons(this.props.exercise.exerciseEntries[0].shuffledMultipleChoiceOptions.length) - _state.DeckUI.layout.buttonHeight - 10 : null;
      }
    }, {
      key: "onClick",
      value: function onClick(exerciseEntry, option) {
        if (!exerciseEntry.state.revealed && (!this.props.cardState || !this.props.cardState.revealed)) {
          var _exerciseEntry$state$2;
          if (!((_exerciseEntry$state$2 = exerciseEntry.state.submittedValue) !== null && _exerciseEntry$state$2 !== void 0 && _exerciseEntry$state$2.includes(option.id))) {
            if ((0, _utils.isPresent)(exerciseEntry.state.submittedValue) && exerciseEntry.numberOfCorrectOptions > 1 && exerciseEntry.selectAllCorrectOptions) {
              exerciseEntry.state.set('submittedValue', [exerciseEntry.state.submittedValue, option.id].join(','));
            } else {
              exerciseEntry.state.set('submittedValue', option.id);
            }
          } else {
            if ((0, _utils.isPresent)(exerciseEntry.state.submittedValue) && exerciseEntry.numberOfCorrectOptions > 1 && exerciseEntry.selectAllCorrectOptions) {
              exerciseEntry.state.set('submittedValue', exerciseEntry.state.submittedValue.split(',').filter(function (item) {
                return item !== option.id;
              }).join(','));
            } else {
              exerciseEntry.state.set('submittedValue', null);
            }
          }
          if (this.props.inDeck) {
            // to do, allow multiple answers entered
            _state.DeckUI.showExerciseAnswer(this.props.card, this.props.cardState, this.props.userCard);
          }
        }
      }
    }, {
      key: "answersMaxWidth",
      value: function answersMaxWidth(exerciseEntry) {
        var _exerciseEntry$mediaO;
        if (_state.ExerciseUI.layout.viewportWidth < 1150 && (0, _utils.isPresent)(exerciseEntry.mediaOptions) && (0, _utils.isPresent)((_exerciseEntry$mediaO = exerciseEntry.mediaOptions[0]) === null || _exerciseEntry$mediaO === void 0 ? void 0 : _exerciseEntry$mediaO.image)) {
          return '620px';
        }
        return null;
      }
    }, {
      key: "setLanguageId",
      value: function setLanguageId(languageId) {
        this.languageId = languageId;
      }
    }, {
      key: "nbOptions",
      value: function nbOptions(exerciseEntry) {
        var _exerciseEntry$multip;
        return (_exerciseEntry$multip = exerciseEntry.multipleChoiceOptions) === null || _exerciseEntry$multip === void 0 ? void 0 : _exerciseEntry$multip.filter(function (item) {
          return (0, _utils.isPresent)(item.targetText);
        }).length;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          exercise: this.exercise,
          mediaWidth: this.mediaWidth,
          onClick: this.onClick,
          optionWidth: this.optionWidth,
          nbOptions: this.nbOptions,
          answersMaxWidth: this.answersMaxWidth,
          background: this.background,
          color: this.color,
          isSelected: this.isSelected,
          languageId: this.languageId,
          setLanguageId: this.setLanguageId,
          sectionHeight: this.sectionHeight
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "languageId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.DeckUI.deckStore.showData.languageId || 'DE';
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "mediaWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mediaWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "exercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "exercise"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "background", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "background"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "color", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isSelected", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "isSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "answersMaxWidth", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "answersMaxWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setLanguageId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setLanguageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nbOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "nbOptions"), _class2.prototype), _class2)) || _class;
};
ExerciseMultipleChoiceMediaWrapper.displayName = 'ExerciseMultipleChoiceMediaWrapper';
var _default = exports["default"] = ExerciseMultipleChoiceMediaWrapper;